import { observer } from "mobx-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRootStore } from "../../stores";
import { Colors } from "../../assets";
import { useNavigate } from "react-router-dom";
import "./styles.css";

const NewOrderAlert = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { newOrderAlertVisible, setNewOrderAlertVisible } =
    useRootStore().rootStore.placeStore;
  const { ordersStatus } = useRootStore().rootStore.orderStore;

  // Auto-dismiss when no waiting orders remain
  useEffect(() => {
    if (newOrderAlertVisible && ordersStatus.isWaiting === 0) {
      setNewOrderAlertVisible(false);
    }
  }, [newOrderAlertVisible, ordersStatus.isWaiting, setNewOrderAlertVisible]);

  if (!newOrderAlertVisible) return null;

  const fontFamily =
    i18n.language === "ar" ? "'Cairo', sans-serif" : "'Rubik', sans-serif";

  return (
    <div className="new-order-alert-overlay" style={{ fontFamily }}>
      <div className="new-order-alert-content">
        <div
          className="new-order-alert-circle"
          style={{ borderColor: Colors.WHITE }}
        >
          <span
            className="new-order-alert-count"
            style={{ color: Colors.WHITE }}
          >
            {ordersStatus.isWaiting}
          </span>
        </div>

        <p className="new-order-alert-title" style={{ color: Colors.WHITE }}>
          {t("you_have_received_new_order")}
        </p>

        <p className="new-order-alert-subtitle" style={{ color: Colors.WHITE }}>
          {t("you_have_minutes_to_accept")}
        </p>

        <button
          className="new-order-alert-button"
          style={{
            backgroundColor: Colors.WHITE,
            color: Colors.GREEN,
          }}
          onClick={() => {
            setNewOrderAlertVisible(false);
            navigate("/main");
          }}
        >
          {t("view_orders")}
        </button>
      </div>
    </div>
  );
};

export default observer(NewOrderAlert);
